import { createReducer, on } from '@ngrx/store';

import {
    IConfigCompras,
    IMontoVentasDia,
    IMontoVentasMes,
    IMontoVentasSemana,
    ITicketsPreventa,
} from '../../private/shared/models/historico-ventas';
import {
    clearVentasMes,
    errroTicketsMesSeleccion,
    errroVentasMes,
    errroVentasMesSeleccion,
    reloadTicketsMesSeleccion,
    reloadVentasMesSeleccion,
    successTicketsMesSeleccion,
    successVentasMes,
    successVentasMesSeleccion,
    ticketsMesSeleccion,
    ventasMes,
    ventasMesSeleccion,
} from '../actions';

interface IProccess {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
}
const Proccess: IProccess = {
    error: null,
    failed: false,
    success: false,
    loading: false,
};

/**
 * * Obtiene configuraciones del mes para ventas y tickets
 */
export interface VentasMesState extends IProccess {
    MontoVentasMes: IMontoVentasMes[];
    ConfigCompras: IConfigCompras;
}

export const VentasMesInit: VentasMesState = {
    ...Proccess,
    MontoVentasMes: [],
    ConfigCompras: null,
};

const _ventasMesReducer = createReducer(
    VentasMesInit,
    on(ventasMes, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successVentasMes, (state, { MontoVentasMes, ConfigCompras }) => (
        {
            ...state,
            loading: false,
            success: true,
            MontoVentasMes,
            ConfigCompras,
        }
    )),
    on(errroVentasMes, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload,
        }
    ))
);

export function VentasMesReducer(state: any, action: any) {
    return _ventasMesReducer(state, action);
}


/**
 * * Obtiene las ventas/tickets y sus montos por mes seleccionado
 */
interface VentasMesSeleccion extends IProccess {
    MontoVentasDia: IMontoVentasDia[];
    MontoVentasSemana: IMontoVentasSemana[];
    FechaMes: string;
    MesActual: boolean;
    IsTicket: boolean;
}
interface TicketsMesSeleccion extends IProccess {
    TicketsPreventa: ITicketsPreventa[];
    InicioMes: string;
    IsTicketPreventa: boolean;
    MesActual: boolean;
}
export interface VentasTicketsMesSeleccionState {
    Ventas: VentasMesSeleccion;
    Preventa: TicketsMesSeleccion;
}

export const VentasTicketsMesSeleccionInit: VentasTicketsMesSeleccionState = {
    Ventas: {
        ...Proccess,
        MontoVentasDia: [],
        MontoVentasSemana: [],
        FechaMes: '',
        MesActual: false,
        IsTicket: false,
    },
    Preventa: {
        ...Proccess,
        TicketsPreventa: [],
        InicioMes: '',
        IsTicketPreventa: false,
        MesActual: false,
    }
};

const _ventasTicketsMesSeleccionReducer = createReducer(
    VentasTicketsMesSeleccionInit,
    on(ventasMesSeleccion, (state, { FechaMes, MesActual }) => (
        {
            ...state,
            Ventas: {
                ...state.Ventas,
                loading: true,
                success: false,
                failed: false,
                FechaMes,
                MesActual,
            }
        }
    )),
    on(successVentasMesSeleccion, (state, { MontoVentasDia, MontoVentasSemana }) => (
        {
            ...state,
            Ventas: {
                ...state.Ventas,
                loading: false,
                success: true,
                MontoVentasDia: (state.Ventas.MesActual
                    ? state.Ventas.MontoVentasDia.filter(mv => mv.MesActual === !state.Ventas.MesActual)
                    : state.Ventas.MontoVentasDia
                ).concat(MontoVentasDia.map(x => ({ ...x, MesActual: state.Ventas.MesActual }))),
                MontoVentasSemana: (state.Ventas.MesActual
                    ? state.Ventas.MontoVentasSemana.filter(mv => mv.MesActual === !state.Ventas.MesActual)
                    : state.Ventas.MontoVentasSemana
                ).concat(MontoVentasSemana.map(x => ({ ...x, MesActual: state.Ventas.MesActual }))),
            }
        }
    )),
    on(reloadVentasMesSeleccion, (state, { MontoVentasDia, MontoVentasSemana }) => (
        {
            ...state,
            Ventas: {
                ...state.Ventas,
                loading: false,
                success: true,
                MontoVentasDia,
                MontoVentasSemana,
            }
        }
    )),
    on(errroVentasMesSeleccion, (state, { payload }) => (
        {
            ...state,
            Ventas: {
                ...state.Ventas,
                loading: false,
                failed: true,
                error: payload,
            }
        }
    )),
    on(ticketsMesSeleccion, (state, { InicioMes, IsTicketPreventa, MesActual }) => (
        {
            ...state,
            Preventa: {
                ...state.Preventa,
                loading: true,
                success: false,
                failed: false,
                InicioMes,
                IsTicketPreventa,
                MesActual,
            }
        }
    )),
    on(successTicketsMesSeleccion, (state, { TicketsPreventa }) => (
        {
            ...state,
            Preventa: {
                ...state.Preventa,
                loading: false,
                success: true,
                TicketsPreventa: (state.Preventa.MesActual
                    ? state.Preventa.TicketsPreventa.filter(mv => mv.MesActual === !state.Ventas.MesActual)
                    : state.Preventa.TicketsPreventa
                ).concat(TicketsPreventa.map(x => ({ ...x, MesActual: state.Ventas.MesActual }))),
            }
        }
    )),
    on(reloadTicketsMesSeleccion, (state, { TicketsPreventa }) => (
        {
            ...state,
            Preventa: {
                ...state.Preventa,
                loading: false,
                success: true,
                TicketsPreventa,
            }
        }
    )),
    on(errroTicketsMesSeleccion, (state, { payload }) => (
        {
            ...state,
            Preventa: {
                ...state.Preventa,
                loading: false,
                failed: true,
                error: payload,
            }
        }
    )),
    on(clearVentasMes, state => (
        {
            ...state,
            ...VentasTicketsMesSeleccionInit
        }
    ))
);

export function VentasTicketsMesSeleccionReducer(state: any, action: any) {
    return _ventasTicketsMesSeleccionReducer(state, action);
}

